import { useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Flag } from 'lucide-react';
import { prefetchRoute } from '@/lib/routePrefetch';

const navItems = [
  { key: 'dashboard', to: '/admin/dash', icon: LayoutDashboard, label: 'Dash' },
  { key: 'tournaments', to: '/admin/tournaments', icon: Flag, label: 'Tournaments' },
];

export const AdminBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (to) => location.pathname === to || location.pathname.startsWith(to + '/');

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-background/95 backdrop-blur-md safe-area-bottom md:hidden"
      data-testid="admin-bottom-nav"
    >
      <div className="max-w-md mx-auto flex items-center justify-around h-14 px-1">
        {navItems.map(({ key, label, icon: Icon, to }) => (
          <button
            key={key}
            onClick={() => navigate(to)}
            onTouchStart={() => prefetchRoute(to)}
            className={`flex flex-col items-center justify-center gap-0.5 flex-1 py-1.5 transition-colors ${
              isActive(to) ? 'text-primary' : 'text-muted-foreground active:text-foreground'
            }`}
            data-testid={`admin-nav-${key}`}
          >
            <Icon className="w-5 h-5" strokeWidth={1.8} />
            <span className="text-[9px] font-medium leading-none">{label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};
